import { useTranslation } from 'next-i18next'

import { Education } from '~/employee/types/employee.types'

export default function EmployeeEducation({ educations }: { educations: Education[] }): React.ReactElement {
  const { t } = useTranslation('ourTeam')
  const concatEducationalDetails = (education: Education): any => {
    return education.degree && education.institute ? (
      <div>
        {education.degree}, <span className="font-bold">{education.institute}</span>
      </div>
    ) : education.degree ? (
      <div>{education.degree}</div>
    ) : (
      <div className="font-bold">{education.institute}</div>
    )
  }

  return (
    <div className="mt-1 mb-4 text-center" data-testid="employee-card-education">
      <div className="font-semibold mb-4 text-black-light" data-testid="education-text">
        {t('education')}
      </div>
      <ul>
        {educations?.map((education, index) => (
          <li className="text-black-light" key={education._key}>
            {index !== 0 && (
              <div className="my-2 lg:my-4" data-testid="education-list-separator">
                <div className="h-px w-full bg-pink-light" />
              </div>
            )}
            {concatEducationalDetails(education)}
          </li>
        ))}
      </ul>
    </div>
  )
}
